var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CheckoutPaymentCardContent',{attrs:{"logo-src":_vm.logo,"logo-width":100,"logo-height":100,"title":_vm.$lang('Rápido y seguro.')}})}
var staticRenderFns = []

export { render, staticRenderFns }